import styled from 'styled-components'

export const ContentSuccess = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  text-align: center;
`
